module.exports = __webpack_public_path__ + "static/media/Pompier.1d844345.png";